import { render, staticRenderFns } from "./learning-areas.vue?vue&type=template&id=5c32ff74"
import script from "./learning-areas.vue?vue&type=script&lang=js"
export * from "./learning-areas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports